import axios from 'axios'

// 生成签名（返回 Promise，不使用 async/await）
function generateSign (appKey, appSecret, text, salt, curtime) {
  const input =
    text.length > 20
      ? text.substring(0, 10) + text.length + text.substring(text.length - 10)
      : text
  const signStr = appKey + input + salt + curtime + appSecret
  const encoder = new TextEncoder()
  const data = encoder.encode(signStr)

  // 返回 Promise
  return crypto.subtle.digest('SHA-256', data).then(hashBuffer => {
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
  })
}

export default {
  fetchTTS (context, data) {
    const appKey = ''
    const appSecret = '' // 已移除：调用方已注释，如需恢复请改走后端代理
    const salt = Date.now().toString()
    const curtime = Math.floor(Date.now() / 1000).toString()

    // 使用 Promise 链式调用
    return generateSign(appKey, appSecret, data.text, salt, curtime)
      .then(sign => {
        const formData = new URLSearchParams()
        formData.append('q', data.text)
        formData.append('appKey', appKey)
        formData.append('salt', salt)
        formData.append('sign', sign)
        formData.append('signType', 'v3')
        formData.append('curtime', curtime)
        formData.append('voiceName', 'youxiaomei')

        return axios.post('https://openapi.youdao.com/ttsapi', formData, {
          responseType: 'blob',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
      })
      .then(response => {
        const audioBlob = response.data
        const audioUrl = URL.createObjectURL(audioBlob)
        return audioUrl // 返回给组件
      })
      .catch(error => {
        console.error('TTS Error:', error)
        throw error // 继续抛出错误
      })
  }
}
